import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "input", "button" ]

  connect() {
    this.buttonTarget.addEventListener('click', () => {
      this.inputTarget.click();
    });
  
    this.inputTarget.addEventListener('change', () => {
      if (this.inputTarget.value) {
        this.inputTarget.form.submit();
      }
    });
  }
}